// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpacePanelActionsButton__button-bd6532 {
  position: absolute;
  inset-inline-end: 16px;
  bottom: 16px;
}

.SpacePanelActionsButton__icon-cafdec {
  pointer-events: none;
}

.SpacePanelActionsButton__menu-ebe1e7 {
  min-width: 216px;
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/SpacePanel/SpacePanelActionsButton/SpacePanelActionsButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,gBAAA;AACF","sourcesContent":[".button {\n  position: absolute;\n  inset-inline-end: 16px;\n  bottom: 16px;\n}\n\n.icon {\n  pointer-events: none;\n}\n\n.menu {\n  min-width: 216px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `SpacePanelActionsButton__button-bd6532`,
	"icon": `SpacePanelActionsButton__icon-cafdec`,
	"menu": `SpacePanelActionsButton__menu-ebe1e7`
};
module.exports = ___CSS_LOADER_EXPORT___;
